module.exports = __webpack_public_path__ + "img/Cara_Verde.5eee5801.svg";